import React from "react";
import { Download } from "react-feather";
import {
  Row,
  Col,
  CardBody,
  CardTitle,
  CardText,
  Spinner,
  Card,
} from "reactstrap";
import {
  getFormattedDateString,
  getFormattedNumber,
  hasPermission,
} from "utility/helpers";
import styled from "styled-components";
import { StyledEditIcon, StyledTrashIcon } from "assets/js/Styles";
import { EDIT_ACTION } from "constants/actions";
import { handleDownloadClick, renderAttachment } from "./utility";

const StyledEventReports = styled(Card)`
  border: none;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 1rem;
`;

const ActionsSection = styled.div`
  margin-top: 10px;
`;

const Container = styled(Row)`
  align-items: center;
`;

const StyledSpinner = styled(Spinner)`
  margin-right: 0.5rem;
`;

const StyledDownloadIcon = styled(Download)`
  margin-right: 0.5rem;
  color: ${({ theme }) => theme.colors.iconBlue};
`;

const EventReports = ({
  filteredReports,
  setImages,
  toggleCarousel,
  setIsDownloadInProgress,
  isDownloadInProgress,
  navigate,
  handleDeleteRow,
}) => {
  return filteredReports?.map((row) => {
    return (
      <StyledEventReports key={row.id}>
        <Container>
          <Col md="3">{renderAttachment(row, setImages, toggleCarousel)}</Col>
          <Col md="9">
            <CardBody>
              <CardTitle tag="h3">{row.title}</CardTitle>
              <Row>
                <Col md="5">
                  <CardText>
                    <strong>{"Venue:"}</strong> {row.venue}
                  </CardText>
                  <CardText>
                    <strong>{"Date:"}</strong>{" "}
                    {getFormattedDateString(row.dateImplemented, "MMM-dd-yyy")}
                  </CardText>
                  <CardText>
                    <strong>{"No. of Beneficiaries:"}</strong>{" "}
                    {row.numberOfBeneficiary}
                  </CardText>
                  <CardText>
                    <strong>{"Principal:"}</strong> {row.Congressman?.fullName}
                  </CardText>
                </Col>
                <Col md="5">
                  <CardText>
                    <strong>{"Cost of Beneficiaries:"}</strong>{" "}
                    {getFormattedNumber(row.costPerBeneficiary)}
                  </CardText>
                  <CardText>
                    <strong>{"Total Cost:"}</strong>{" "}
                    {getFormattedNumber(row.totalCost)}
                  </CardText>
                  <CardText>
                    <strong>{"Others:"}</strong> {row.partners}
                  </CardText>
                </Col>
                <Col md="2">
                  <ActionsSection>
                    {isDownloadInProgress[row.id] ? (
                      <StyledSpinner
                        animation="border"
                        color="dark"
                        size="sm"
                      />
                    ) : (
                      <StyledDownloadIcon
                        size={16}
                        onClick={() => {
                          setIsDownloadInProgress((prev) => ({
                            ...prev,
                            [row.id]: true,
                          }));

                          handleDownloadClick(
                            row.xlsxLinks,
                            row.attachments,
                            row.title,
                            row.id,
                            setIsDownloadInProgress
                          );
                        }}
                      />
                    )}

                    {hasPermission("utilization-update") && (
                      <StyledEditIcon
                        size={16}
                        id={`edit-row--${row.id}`}
                        style={
                          row.id !== isDownloadInProgress
                            ? { cursor: "pointer" }
                            : {
                                cursor: "initial",
                                pointerEvents: "none",
                              }
                        }
                        onClick={() => {
                          navigate("/utilization/edit", {
                            state: {
                              row,
                              action: EDIT_ACTION,
                            },
                          });
                        }}
                      />
                    )}
                    {hasPermission("utilization-create") && (
                      <StyledTrashIcon
                        size={16}
                        style={
                          row.id !== isDownloadInProgress
                            ? { cursor: "pointer" }
                            : {
                                cursor: "initial",
                                pointerEvents: "none",
                              }
                        }
                        onClick={() => handleDeleteRow(row)}
                        id={`delete-row--${row.id}`}
                      />
                    )}
                  </ActionsSection>
                </Col>
              </Row>
            </CardBody>
          </Col>
        </Container>
      </StyledEventReports>
    );
  });
};

export default EventReports;
